import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsTestUserLookupComponent } from './is-TestUser-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [IsTestUserLookupComponent],
  exports: [IsTestUserLookupComponent]

})
export class IsTestUserLookupModule { }
